import { connect } from 'react-redux'
import { fetchCreditCards, addCreditCard } from './creditCardActions'

import CreditCards from './CreditCards'

const mapStateToProps = (state) => ({
  cards: state.creditCards.cards,
  personId: state.authorization.personId
})

const mapDispatchToProps = dispatch => ({
  fetchCreditCards: personId => dispatch(fetchCreditCards(personId)),
  addCreditCard: (personId, cardNumber, expirationDate, cardHolderName) => dispatch(
    addCreditCard(personId, cardNumber, expirationDate, cardHolderName)
  )
})

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  fetchCreditCards: () => dispatchProps.fetchCreditCards(stateProps.personId),
  addCreditCard: (cardNumber, expirationDate, cardHolderName) =>
    dispatchProps.addCreditCard(stateProps.personId, cardNumber, expirationDate, cardHolderName)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(CreditCards)
